<template>
    <div>
        <div class="flex-center flex-column px-16">
            <img
                class="mb-40"
                src="/app/images/smart-terminal-login-required.svg"
                alt="Smart Terminal Required">

            <p class="heading-grande-medium mb-24">Login Required</p>

            <p class="smart-terminal-block-text d-flex flex-column mb-40 text-center">
                <span class="text-grande-regular">The equipment store is only available to Helcim Merchants.</span>
                <span class="text-grande-regular"> Please log in and navigate to the Equipment tool.</span>
            </p>
        </div>
        <div class="hub-button-stack d-flex gap-16">
            <Button
                class="mb-24 w-75"
                text="Sign up with Helcim"
                variant="secondary"
                fluid
                @click="redirectToHubSignUp()"/>

            <Button
                class="mb-24 w-75"
                text="Login"
                variant="primary"
                fluid
                @click="redirectToHubLogin()"/>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Button } from '@helcim/blizzard';

const redirectToHubSignUp = () => {
    window.location.href = 'https://hub.helcim.com/signup/register';
};

const redirectToHubLogin = () => {
    window.location.href = 'https://hsso.helcim.com/login';
};

</script>

<style lang="scss">
@media only screen and (max-width: 480px) {
    .hub-button-stack {
        flex-direction: column-reverse;
        gap: 0;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .smart-terminal-block-text {
        display: block;
    }
}
</style>